import { Paper, Typography } from "@mui/material";

export default function PurchaseBehaviorMetric({
    label,
    tone = "normal",
    value,
}: {
    label: string;
    tone?: "normal" | "warning";
    value: string;
}) {
    return (
        <Paper
            className="metric-card"
            elevation={0}
            sx={{
                borderColor: tone === "warning" ? "rgba(245, 158, 11, 0.42)" : undefined,
                background: tone === "warning" ? "rgba(255, 251, 235, 0.84)" : undefined,
            }}
        >
            <Typography variant="overline" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 900, mt: 0.25 }}>
                {value}
            </Typography>
        </Paper>
    );
}
